export default __webpack_public_path__ + "static/media/clock.23fb7a1b.svg";